"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplicationType = exports.Locale = void 0;
var Locale;
(function (Locale) {
    Locale["en_US"] = "en-US";
    Locale["ko_KR"] = "ko-KR";
})(Locale || (exports.Locale = Locale = {}));
var ApplicationType;
(function (ApplicationType) {
    ApplicationType["RealtimeInference"] = "RealtimeInference";
})(ApplicationType || (exports.ApplicationType = ApplicationType = {}));
